import clsx from "clsx";
import { useSelectDropdownContext } from "../root/SelectDropdown.root";
import styling from "./selectOption.module.scss";
import { Button } from "src/components/button/Button";

export namespace SelectOption {
	export type ElementName = "button";
	export type ElementType = HTMLButtonElement;
	export type Props = Omit<Button.Props, "onClick" | "value"> & {
		onSelectItem?: () => void;
		value?: any;
	};
}

export const SelectOption = (props: SelectOption.Props) => {
	const {
		text,
		children,
		color = "neutral",
		variant = "ghost",
		state,
		onSelectItem,
		...rest
	} = props;
	const { selectedItem, onSelectChange } = useSelectDropdownContext();

	if (selectedItem && selectedItem.id === props.id) {
		return null;
	}

	return (
		<Button
			className={clsx(styling.item)}
			state={state}
			text={text}
			color={color}
			variant={variant}
			onClick={() => {
				if (props.id !== selectedItem?.id) {
					onSelectChange(props);
				}
			}}
			{...rest}
		>
			{children}
		</Button>
	);
};
